import { render } from "./SaveQualificationSkill.vue?vue&type=template&id=2da150b9"
import script from "./SaveQualificationSkill.vue?vue&type=script&lang=js"
export * from "./SaveQualificationSkill.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__